import { ApiError } from '../api/client'
import { translate } from '../i18n/translate'
import { useUiStore } from '../stores/ui'

export function errText(err: unknown): string {
    if (err instanceof ApiError) return err.message
    // Fallback direkt über den Store übersetzen — errText wird auch
    // außerhalb von Komponenten aufgerufen (z. B. in Mutation-Callbacks).
    return translate(useUiStore.getState().language, 'errors.unexpected')
}
